import { Flex } from "@chakra-ui/react";
import React from "react";
import { usePageComponents } from "lib/cms/usePageComponents";
import { useLandingPageContext } from "packages/acquisition/components/chakra-components/LandingPage/LandingPageProvider";
import { ATBConfirmation } from "basket_and_checkout/shared/components/ATBConfirmation";

type Props = {
  blocks: unknown[];
  isMember: boolean;
};

export const Homepage: React.FC<Props> = ({ blocks, isMember }) => {
  const components = usePageComponents(blocks, isMember);
  const { ATBConfirmation: ATBConfirmationState, setATBConfirmation } =
    useLandingPageContext();

  return (
    <Flex w="full" direction="column" align="center" maxWidth="90rem" mx="auto">
      {ATBConfirmationState && (
        <ATBConfirmation
          confirmation={ATBConfirmationState}
          setConfirmation={setATBConfirmation}
          source="LandingPage"
        />
      )}
      {components}
    </Flex>
  );
};
